// --notes
// l:left, r:right, b:bottom, t:top, w:white, b:black
// import use images
// import images from "../../images"
//Image Example
import ImageMain from "./imageExample/thumbnail.png";
import ImageSamll1 from "./imageExample/imageSmallExample.png";
import ImageSamll2 from "./imageExample/imageSmallExample2.png";
import ImageSamll3 from "./imageExample/imageSmallExample3.png";
import FlagImage from "./imageExample/flag.png";
import Thumnail2 from "./imageExample/thumbnail2.jpeg";
import Thumnail3 from "./imageExample/thumbnail3.jpeg";
import LogoThumnail2 from "./imageExample/logoBread.png";
import LogoThumnail3 from "./imageExample/logothumnail3.jpg";
//Home
import ReviewChallengeImage from "./home/reviewChallengeImage.png";
import OngoingImage from "./home/onGoingImage.png";
import RallyLogo2 from "./home/rallyLogo2.png";

// Import IMAGES
import DefaultUploadImage from "./uploadIcon/defaultUpload.png";
import DeleteIcon from "./uploadIcon/deleteIcon.png";
import TrashWhiteIcon from "./uploadIcon/trashIconWhite.png";
import ReviewReceiptImage from "./uploadIcon/reviewReceiptImageModal.png";
import IconPNGImage from "./uploadIcon/iconPngImage.png";
import IconPDF from "./uploadIcon/iconPdf.png";
import ImageNameShop from "./icon/logoAskCoffe.png";
import TreasureChest from "./imageExample/treasureChest.png";
import StartPage1 from "./imageExample/startPage1.png";
import StartPage2 from "./imageExample/startPage2.png";
import PayNow from "./imageExample/paynow.png";
import Earning from "./imageExample/earning.png";

//Icon
import MapIcon from "./icon/mapIcon.png";
import FavoritesIcon from "./icon/Favorite.png";
import FavoritesIconActive from "./icon/favoritesActiveIcon.png";
import TagIcon from "./icon/tagIcon.png";
import Pause from "./icon/Pause.png";
import User03 from "./icon/User03Black.svg";
import Clock from "./icon/Clock.svg";
import User03Red from "./icon/User03Red.svg";
import PauseBlackIcon from "./icon/pauseBlackIcon.svg";

import DailyQuota from "./icon/quotaCheckIconBlack.svg";
import DailyQuotaRed from "./icon/quotaCheckIconRed.svg";
import CalendarDefault from "./icon/Calendar__default.png";
import RallyCoinDisabled from "./icon/rally_coin_disabled.png";
import ClockDisabled from "./icon/Clock_disabled.png";
import User03Disabled from "./icon/User_03_disabled.png";

import Introduce from "./imageExample/introduce.svg";
import ExperienceTRail from "./imageExample/experienceTrail.svg";
import VibeCheck from "./imageExample/vibeCheck.svg";
import Snap from "./imageExample/snap.svg";
import IntroduceDisable from "./imageExample/introduceDisable.svg";
import ExperienceTrailDisable from "./imageExample/trailDisable.svg";
import VibeCheckDisable from "./imageExample/vibeDisable.svg";
import SnapDisable from "./imageExample/snapDisable.svg";

import LeftArrowNew from "./icon/Arrow_Left_LG.png";
import SendIcon from "./icon/sendIcon.svg";
import ClockCircleIcon from "./icon/clockCircleIcon.png";
import CalendarIcon from "./icon/calendarIcon.png";
import StartQuestIcon from "./icon/starQuestIcon.png";
import LogoIcon from "./home/logoIcon.png";
import PointGetIcon from "./icon/pointGetIcon.png";
import HomeIcon from "./icon/homeIcon.png";
import HomeActiveIcon from "./icon/homeActiveIcon.png";
import QuestIcon from "./icon/questIcon.png";
import QuestActiveIcon from "./icon/questActiveIcon.png";
import TutorialIcon from "./icon/tutorialIcon.png";
import TutorialActiveIcon from "./icon/tutorialActiveIcon.png";
import ProfileIcon from "./icon/profileIcon.png";
import ProfileActiveIcon from "./icon/profileActiveIcon.png";
import PrevIcon from "./icon/prevIcon.png";
import NextIcon from "./icon/nextIcon.png";
import NextDisableIcon from "./icon/nextDisableIcon.png";
import NextWhiteIcon from "./icon/nextWhiteIcon.png";
import TickIcon from "./icon/tickIcon.png";
import DoubleArrowIcon from "./icon/doubleUpIcon.png";
import EditIcon from "./icon/editIcon.png";
import PointIconBlue from "./icon/pointIconBlue.png";
import ThreeDotIcon from "./icon/threeDotIcon.png";
import ThreeDotVerticalIcon from "./icon/threeDotIconVertical.png";

import DotMapIconWhite from "./icon/dotMapIcon.png";
import PreviousIcon from "./icon/previousIcon.png";
import NextIco from "./icon/nextIco.png";
import listIcon from "./icon/listIcon.png";
import SearchIcon from "./icon/SearchIcon.png";
import CoinIcon from "./icon/coinIcon.png";
import CarbonCloseOutline from "./icon/carbonCloseOutline.png";
import CarbonPauseOutline from "./icon/carbonPauseOutline.png";
import CarbonCloseOutlineBlue from "./icon/carbonCloseOutlineBlue.png";
import CarbonPauseOutlineBlue from "./icon/carbonPauseOutlineBlue.png";
import DotmapBlueIcon from "./icon/dotmapBlueIcon.png";
import RetailStoreIcon from "./icon/retailStoreIcon.png";
import OclockIconRed from "./icon/oclockIconRed.svg";
import SaveIcon from "./icon/saveIcon.svg";

import TickIconWhite from "./icon/tickIconWhite.png";
import RallyCoins from "./icon/rallyCoin.png";
import CalendarIcon2 from "./icon/calendar.png";
import User3Icon from "./icon/user03.png";
import RallyCoinSmallWhiteIcon from "./icon/rallyCoinSmallWhiteIcon.png";
import RallyXPSmallWhiteIcon from "./icon/rallyXPSmallWhiteIcon.png";
import UserSmallWhiteIcon from "./icon/userSmallWhiteIcon.png";
import MapPinIcon from "./icon/mapPinIcon.png";
import RallyXPSmallBlueIcon from "./icon/rallyXPSmallBlueIcon.png";
import RallyCoinSmallBlueIcon from "./icon/rallyCoinSmallBlueIcon.png";
import Heart02Icon from "./icon/heart02Icon.png";
import Heart02ActiveIcon from "./icon/heart02ActiveIcon.png";
import AlarmIcon from "./icon/alarmIcon.png";
import AlarmIconRed from "./icon/alarmIconRed.png";
import SearchMagnifyingGlass from "./icon/searchMagnifyingGlass.png";
import HeartGrayIcon from "./icon/heartGrayIcon.png";
import ArrowLeftIconWhite from "./icon/arrowLeftIconWhite.png";
import ArrowRightIconBlue from "./icon/arrowRightIcon.png";
import OclockIconSVG from "./icon/oclockIconSVG.svg";
import PhoneIconSVG from "./icon/phoneIconSVG.svg";

// import ArrowLeftIconBlue from "./icon/arrowRightIcon.png";

import ArrowLeftIcon from "./icon/arrowLeftIcon.png";
import EditIconBlue from "./icon/editPencilIconBlue.png";
import StartIcon from "./icon/starIcon.png";

import ClockIconBlue from "./icon/clockIconBlue.png";
import WarningIconRed from "./icon/warningIconRed.png";
import PhoneIcon2 from "./icon/phoneIcon2.png";
import MapIcon2Blue from "./icon/mapIcon2Blue.png";
import InfoIconGray from "./icon/infoIconGray.png";
import CircleHelpIconBlue from "./icon/circleHelpIconBlue.png";
import CloseModalIconGray from "./icon/closeModalIconGray.png";
import TipsQuestIcon from "./icon/tipsQuestIcon.png";
import User03BlueIcon from "./icon/user03BlueIcon.png";

import Lightning from "./icon/lightning.png";
import LightningLeft from "./icon/lightningLeft.png";
import LightningRight from "./icon/lightningRight.png";
import Star from "./icon/star.png";
import RallyLogo from "./quest/Rally_logo.png";
import Earning1 from "./quest/earning.png";
import TipQuestion from "./quest/tipQuestion.png";
import RallyCointWhite from "./quest/rallyCoinWhite.png";
import ShareIcon from "./icon/shareIcon.png";
import CircleWarningIconBlue from "./icon/circleWarningIconBlue.png";

//Login

import WhatsappIcon from "./login/whatsappIcon.png";
import UserIcon from "./login/userIcon.png";
import PhoneIcon from "./login/phoneIcon.png";
import LogoLogin from "./login/logoLogin.png";
import GenderIcon from "./login/genderIcon.png";
import BackIcon from "./icon/backIcon.png";
import MenuIcon from "./icon/menuIcon.png";
import OclockIcon from "./icon/oclockIcon.png";
import QRScanImage from "./login/qrRally.png";
import WhatsappIconWhite from "./login/whatsappIconWhite.png";
import UnfoldMoreIcon from "./icon/unfoldMoreIcon.png";
import ChevronDownIcon from "./icon/chevronDownIcon.png";
import ChevronDownIcon2x from "./icon/chevronDownIcon2x.png";

import DropPhoneIconGray from "./login/dropPhoneIconGray.png";

//Quest Image
import TaskQuestModalImage from "./quest/taskQuestModalImage.png";
import PauseQuestImageModal from "./quest/pauseQuestImage.png";
import SubmitQuestImageModal from "./quest/submitQuestImage.png";
import ReviewCompleteQuestImageModal from "./quest/questReviewCompleteImg.png";
import CompleteQuestImage from "./quest/questCompleteImage.png";
import Illustrations from "./quest/illustrations.png";
import QuestUnderReview from "./quest/questUnderReview.png";
import DefaultImageQuest from "./quest/defaultImageQuest.png";
import CompleteQuestImagePerLocation from "./quest/completedQuest.svg";

//Profile

import LogoProfile from "./profile/logoProfile.png";
import UpdateModalImage from "./profile/updateModalImage.png";
import PayNowImage from "./profile/payNowImage.png";
import CheckCircleIcon from "./profile/checkCircleIcon.png";
import WithdrawSuccessImage from "./profile/withDrawSuccessImage.png";
import GiftIcon from "./profile/giftIcon.png";
import ChevronRightIcon from "./profile/ChevronRightIcon.png";
import ArrowLeftIconGray from "./profile/arrowLeftIconGray.png";
import RallyPowerUp from "./profile/RallyPowerUp.png";
import RookieRush from "./profile/RookieRush.png";
import Copy from "./profile/Copy.png";
import XPProfileImage from "./profile/xpProfileImage.svg";
import RallyPowerUpImage from "./profile/rallyPowerUp.svg";
import SubPowerUpImage from "./profile/subImagePowerUp.svg";
import SubPowerUpImageSecond from "./profile/subImagePowerUpSecond.svg";

//OP preview
import PreviewImage from "./login/previewImage.png";
import OPPreviewImageStep2 from "./login/OPPreviewImage2.png";
import OPPreviewImageStep3 from "./login/OPPreviewImage3.png";
import ReviewingQuestImage from "./quest/reviewingImage.png";
import ReviewingQuestCompletedImage from "./quest/reviewingCompleteImage.png";
import QuestCompletedImage from "./quest/questCompletedImage.png";

//Tutorial
import TutorialImage from "./tutorial/tutorial.png";
import trophyIcon from "./icon/trophyIcon.png";

// Badges
import BadgeLevel1 from "./profile/BadgeLevel1.png";

// Export your image
const images = {
  //images
  DefaultUploadImage,
  DeleteIcon,
  TrashWhiteIcon,
  ReviewReceiptImage,
  IconPNGImage,
  IconPDF,
  MapIcon,
  FavoritesIcon,
  ClockCircleIcon,
  CalendarIcon,
  StartQuestIcon,
  LogoIcon,
  PointGetIcon,
  TreasureChest,
  StartPage1,
  StartPage2,
  PayNow,
  Earning,

  //Preview
  PreviewImage,
  OPPreviewImageStep2,
  OPPreviewImageStep3,

  //Home image
  ReviewChallengeImage,
  OngoingImage,
  RallyLogo2,

  //Icon Login
  TagIcon,
  FavoritesIconActive,
  WhatsappIcon,
  UserIcon,
  PhoneIcon,
  LogoLogin,
  GenderIcon,
  HomeIcon,
  HomeActiveIcon,
  QuestIcon,
  QuestActiveIcon,
  TutorialIcon,
  TutorialActiveIcon,
  ProfileIcon,
  ProfileActiveIcon,
  PrevIcon,
  NextIcon,
  NextDisableIcon,
  NextWhiteIcon,
  BackIcon,
  MenuIcon,
  TickIcon,
  OclockIcon,
  DoubleArrowIcon,
  QRScanImage,
  ThreeDotIcon,
  ThreeDotVerticalIcon,
  WhatsappIconWhite,
  DotMapIconWhite,
  DotmapBlueIcon,
  OclockIconRed,
  SaveIcon,
  TickIconWhite,
  RallyCoinSmallWhiteIcon,
  RallyXPSmallWhiteIcon,
  UserSmallWhiteIcon,
  ChevronDownIcon,
  ChevronDownIcon2x,
  UnfoldMoreIcon,
  DropPhoneIconGray,
  User03BlueIcon,
  CircleWarningIconBlue,
  PhoneIconSVG,
  OclockIconSVG,
  //Quest Image
  TaskQuestModalImage,
  PauseQuestImageModal,
  SubmitQuestImageModal,
  ReviewCompleteQuestImageModal,
  CompleteQuestImage,
  PointIconBlue,
  CoinIcon,
  CarbonCloseOutline,
  CarbonPauseOutline,
  CarbonCloseOutlineBlue,
  CarbonPauseOutlineBlue,
  RetailStoreIcon,
  RallyCoins,
  CalendarIcon2,
  User3Icon,
  MapPinIcon,
  RallyXPSmallBlueIcon,
  RallyCoinSmallBlueIcon,
  Heart02Icon,
  Heart02ActiveIcon,
  AlarmIcon,
  AlarmIconRed,
  SearchMagnifyingGlass,
  HeartGrayIcon,
  ArrowLeftIconWhite,
  ArrowRightIconBlue,
  DefaultImageQuest,
  SendIcon,
  CompleteQuestImagePerLocation,
  // ArrowLeftIconBlue,
  ArrowLeftIcon,
  StartIcon,
  EditIcon,
  EditIconBlue,
  ClockIconBlue,
  WarningIconRed,
  PhoneIcon2,
  MapIcon2Blue,
  InfoIconGray,
  Illustrations,
  CircleHelpIconBlue,
  CloseModalIconGray,
  TipsQuestIcon,
  ReviewingQuestImage,
  ReviewingQuestCompletedImage,
  QuestCompletedImage,
  QuestUnderReview,
  PauseBlackIcon,
  //Profile
  LogoProfile,
  UpdateModalImage,
  PayNowImage,
  FlagImage,
  CheckCircleIcon,
  WithdrawSuccessImage,
  GiftIcon,
  ChevronRightIcon,
  ArrowLeftIconGray,
  XPProfileImage,
  RallyPowerUpImage,
  SubPowerUpImage,
  SubPowerUpImageSecond,
  //Image Example
  ImageMain,
  ImageSamll1,
  ImageSamll2,
  ImageSamll3,
  ImageNameShop,

  //tutorial
  TutorialImage,
  //icon tutorial
  PreviousIcon,
  NextIco,
  listIcon,
  SearchIcon,
  trophyIcon,
  Thumnail2,
  Thumnail3,
  LogoThumnail2,
  LogoThumnail3,

  // icon quest completed - story post
  Lightning,
  LightningLeft,
  LightningRight,
  Star,
  RallyLogo,
  Earning1,
  TipQuestion,
  RallyCointWhite,
  ShareIcon,

  // icon quest details
  Pause,
  Clock,
  User03,
  User03Red,
  DailyQuota,
  DailyQuotaRed,
  CalendarDefault,
  RallyCoinDisabled,
  ClockDisabled,
  User03Disabled,
  Introduce,
  ExperienceTRail,
  VibeCheck,
  Snap,
  LeftArrowNew,
  IntroduceDisable,
  ExperienceTrailDisable,
  VibeCheckDisable,
  SnapDisable,
  // badges
  BadgeLevel1,
  // power up
  RallyPowerUp,
  RookieRush,
  Copy,
};

export default images;
